import React, { useContext, useEffect, useRef, useState } from "react";

import { Badge, ButtonGroup, Tab, Tabs } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Table from "react-bootstrap/Table";

import { FolderMinus, FolderX } from 'react-bootstrap-icons';


import {
  A,
  ANALITICO,
  ATRIBUTOS_FILTRO_RELATORIO_ANALITICO,
  ATRIBUTOS_HEADER_RELATORIO_ANALITICO_CSV,
  B,
  BRANCO,
  CEPZERO,
  CODSRO_OBJETO_UNITIZADOR,
  DATA_SELECIONADA,
  ETIQUETA_PATTERN_NUMERO_INTERROGACAO,
  IDHASHUNITIZADOR,
  N,
  SINTETICO,
  TODOS,
  VAZIO,
  VENCER, VENCIDO,
  VERDE, VERMELHO
} from "../utils/Constants";
import telaTabelaCabecalho from './relatorios/TelaTabelaCabecalho';

import { Justify, Search, SortDown, SortUp } from "react-bootstrap-icons";

import { useNavigate } from "react-router-dom";
import FiltrarExportar from "../../../components/FiltrarExportar";
import PaginationComponent from "../../../components/Pagination";
import ToastCustomizado from "../../../components/Toast";
import { api } from "../../../services/Api";
import { AuthContext } from '../../../store/AuthContext';
import { Constants } from "../../../util/Constants";
import { dataAtualFormatada, dataHoraAtualMenosDiasFormatada, dateTimeStringToISOFormat, montaMenssagemRetornoErroPromiseAllSettled } from "../../../util/FuncoesComuns";
import { AlertaExpedicaoContext } from "../contextsAlerta/AlertaExpedicao";
import { createItemAlertaAlterar } from "../interfaces/IItem";
import { IMotivoConferencia } from "../interfaces/IMotivoConferencia";
import ITable from "../interfaces/ITable";
import IUnidadeUnitizadoresItensGeralAlerta from "../interfaces/IUnidadeUnitizadoresItensGeralAlerta";
import { IUnitizador } from "../interfaces/IUnitizador";
import { aplicarFiltro, montarAtributosRetorioAnalitico } from "../utils/Filtros";
import { downloadBase64PDF, gerarHashMd5ParaPDF } from "../utils/FuncoesPDF";
import { Mensagem } from "../utils/mensagem";
import EctAlertaNaoUrgente from './../../../assets/img/AlertaCargaNaoUrgente.png';
import EctAlertaUrgente from './../../../assets/img/AlertaCargaUrgente.png';
import ModalSituacao from "./Modal";
import ConsultaObjetoPorCombinacao from "./Modal/consultaObjetoPorCombinacao";
import { montaRetornoUnitizadorPadraoPagination } from "./Unitizador";
import "./index.css";
import downloadAnaliticoExcluidosPdf from "./relatorios/analiticoExcluidosPdf";
import downloadAnaliticoFaltantesPdf from "./relatorios/analiticoFaltantesPdf";
import downloadAnaliticoPendentesPdf from "./relatorios/analiticoPendentesPdf";

interface Props {
  linkClicado: (key: any) => void;
  isLinkClicado: (key: any) => boolean;
}

interface IQtdItemAlertaSituacao {
  pendente: number; //N
  faltante: number; //F
  excluido: number; //X
  local: number; //T
  nacional: number; //P
}

const mapStatus: Map<string, string> = new Map([
  ['N', 'Pendentes'],
  ['E', 'Excluídos'],
  ['F', 'Faltantes'],
  ['T', 'Local'],
  ['P', 'Nacional'],
  ['pendente', 'N'],
  ['excluido', 'E'],
  ['faltante', 'F'],
  ['pendentes', 'N'],
  ['excluidos', 'E'],
  ['faltantes', 'F'],
  ['local', 'T'],
  ['nacional', 'P'],
]);

const mapSortingCampoDatetime: Map<string, string> = new Map([
  ['dataExpedicao', ''],
  ['dataRecebido', ''],
  ['dataAlterado', ''],
  ['dataMaximaPrazo', ''],
]);

const ListaUnitizadorUnidadeDataObjetos = ({ linkClicado, isLinkClicado }: Props) => {

  const navigate = useNavigate();
  const didMountRef = useRef(false);
  const { user, setErro } = useContext(AuthContext);
  const divTable = useRef<null | HTMLInputElement>(null);
  const chkCabecalho = useRef<null | HTMLInputElement>(null);
  const [mensagem, setMensagem] = useState<Mensagem>({ delay: 5000, tipo: '', texto: '', url: '/alerta-expedicao' });
  const [columns, setColumns] = useState<ITable[]>([]);
  const [tabLocal] = useState<string>(ANALITICO);
  const [filtro, setFiltro] = useState<string>('');
  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");
  const [listaUnidadeUnitizadoresItensGeralAlerta, setListaUnidadeUnitizadoresItensGeralAlerta] = useState<IUnidadeUnitizadoresItensGeralAlerta[]>([]);
  const [listaUnidadeUnitizadoresItensGeralAlertaFiltrada, setListaUnidadeUnitizadoresItensGeralAlertaFiltrada] = useState<IUnidadeUnitizadoresItensGeralAlerta[]>([]);
  const [mapLinhasSelecionadas, setMapLinhasSelecionadas] = useState<Map<String, IUnidadeUnitizadoresItensGeralAlerta>>(new Map<String, IUnidadeUnitizadoresItensGeralAlerta>());
  const [selecionarTodos, setSelecionarTodos] = useState<boolean>(false);
  const [motivos, setMotivos] = useState<IMotivoConferencia[]>([]);
  const [motivoSelecionado, setMotivoSelecionado] = useState<IMotivoConferencia | null>(null);
  const [motivosFiltrados, setMotivosFiltrados] = useState<IMotivoConferencia[]>([]);
  const [show, setShow] = useState<boolean>(false);
  const [showModalObjetoCombinacao, setShowModalObjetoCombinacao] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [qtdItensAlertaSituacao, setQtdItensAlertaSituacao] = useState<IQtdItemAlertaSituacao>({ pendente: 0, faltante: 0, excluido: 0, local: 0, nacional: 0 })
  const [keyTabLocal, setKeyTabLocal] = useState<string>('pendente');
  const [keyTabBtnConsultarCodSroOUUniOuObj, setKeyTabBtnConsultarCodSroOUUniOuObj] = useState<string>('A');
  const [numUnitizadorConsultar, setNumUnitizadorConsultar] = useState<string>('');
  const [, setUnitizador] = useState<IUnitizador | undefined>(undefined);
  const [isTabsLocalNacional, setIsTabsLocalNacional] = useState<boolean>(false);
  const [listaObjetoCombinacoes, setListaObjetoCombinacoes] = useState<any>(undefined);
  const [numObjetoConsultado, setNumObjetoConsultado] = useState<string>('');
  const [valoresPaginacao, setValoresPaginacao] = useState<any>({});
  const [currentPage, setCurrentPage] = useState(0);

  const {
    key,
    keyTabTipoCarga, setKeyTabTipoCarga,
    codSroUnidadeOrigem, setCodSroUnidadeOrigem,
    dataSelecionada, setDataSelecionada,
    setShowSpinner,
    iPreAlertaUnitizador, setIPreAlertaUnitizador,
    tipoConsultaNaApi, setTipoConsultaNaApi,
  } = useContext(AlertaExpedicaoContext)

  useEffect(() => {

    didMountRef.current = false;
    setCodSroUnidadeOrigem(()=>CEPZERO);
    setShowSpinner(()=>true);

    (async function () {

      const [resMotivos] = await Promise.allSettled([api.get('/v1/motivo-exclusao-conferencia')]);
      if (resMotivos.status === 'fulfilled') {

        const res = await resMotivos.value.data;
        setMotivos(() => res);

      } else if (resMotivos.status === 'rejected') {
        let msg = montaMenssagemRetornoErroPromiseAllSettled(resMotivos, 'Erro ao chamar /v1/motivo-exclusao-conferencia - Rejeitado.');
        setErro({ delay: 5000, tipo: 'danger', texto: msg, url: '/erro' });
        navigate('/erro')
      } else {
        setErro({ delay: 5000, tipo: 'warning', texto: `Alerta : Erro ao chamar /v1/motivo-exclusao-conferencia.`, url: '/erro' });
        navigate('/erro')
      }

    })();

    setConfigTableDefault();

    if (iPreAlertaUnitizador && iPreAlertaUnitizador.id) {
      setNumUnitizadorConsultar(() => iPreAlertaUnitizador.numUnitizador);
      consultarUnitizadorPeloIdHash();
    } else {
      consultarUnitizadoresUnidadeDataObjetosSelecionada();
    }

    return () => {
      //unmount
      setCodSroUnidadeOrigem(() => CEPZERO);
      setDataSelecionada(() => '1900-01-01');
      setIPreAlertaUnitizador(() => null)
      didMountRef.current = false;
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setConfigTableDefault = () => {
    setColumns(() => telaTabelaCabecalho(ANALITICO, 'N', keyTabLocal));
    setCurrentPage(() => 0);
    setMotivoSelecionado(() => null)
    mapLinhasSelecionadas.clear();
    //selecionarTodosItens(null);
  };

  //Executado quando currentPage é alterada (0,1,2,..).
  useEffect(() => {
    if (!didMountRef.current) {
      return; // 🚫 Não executa na montagem inicial
    }
    requestApi(tipoConsultaNaApi);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  //Executado quando keyTabLocal é alterado (pendentes,faltantes,excluidos, local, nacional).
  useEffect(() => {
    if (!didMountRef.current) {
      return; // 🚫 Não executa na montagem inicial
    }

    setConfigTableDefault();
    //Consulta no banco de dados rastro via api.
    requestApi(TODOS);

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyTabLocal]);

  //Executado quando keyTabTipoCarga é alterado (URG,NURG,MISTA).
  useEffect(() => {

    if (!didMountRef.current) {
      return; // 🚫 Não executa na montagem inicial
    }

    setConfigTableDefault();

    setShowSpinner(() => true);

    setCurrentPage(() => 0);
    if (key === 'objetos') {
      if (!dataSelecionada) setDataSelecionada(() => '1900-01-01')
    }

    setConfigTableDefault();
    //Consulta no banco de dados rastro via api.
    requestApi(TODOS);
    setShowSpinner(() => false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyTabTipoCarga])

  //Executado quando keyTabBtnConsultarCodSroOUUniOuObj é alterado (A,B).
  useEffect(() => {
    if (!didMountRef.current) {
      return; // 🚫 Não executa na montagem inicial
    }

    setConfigTableDefault();
    requestApi(CODSRO_OBJETO_UNITIZADOR);

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyTabBtnConsultarCodSroOUUniOuObj]);

  useEffect(() => {
    aplicarFiltroInputUsuario(filtro);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listaUnidadeUnitizadoresItensGeralAlerta])

  useEffect(() => {

    (async function () {

      if (motivoSelecionado) {
        setShowSpinner(() => true);
        let itensAtualizar: any[] = [];
        const login = user && user.matricula ? user.matricula : user.sub && !isNaN(user.sub) ? user.sub : user.idCorreios && !isNaN(user.idCorreios) ? user.idCorreios : user.cpf && !isNaN(user.cpf) ? user.cpf : '00000008';

        mapLinhasSelecionadas.forEach((item, key) => {
          let itemAlterar = createItemAlertaAlterar(
            user?.unidadeSro?.codigoSro,
            login,
            motivoSelecionado && motivoSelecionado.tipo ? motivoSelecionado.tipo : 'F',
            motivoSelecionado && motivoSelecionado.motivo ? motivoSelecionado.motivo : 1,
            motivoSelecionado && motivoSelecionado.id ? String(motivoSelecionado.id) : '100',
            item
          );
          itensAtualizar.push(itemAlterar);
        })

        const [resUunitizador] = await Promise.allSettled([api.put(`/v1/expedicoes-pre-alertas-item/itens`, itensAtualizar)]);

        if (resUunitizador.status === 'fulfilled') {

          iPreAlertaUnitizador && iPreAlertaUnitizador.id ? consultarUnitizadorPeloIdHash() : consultarUnitizadoresUnidadeDataObjetosSelecionada();

          setMensagem({ delay: 2000, tipo: 'info', texto: `Ok : Alteração com sucesso.`, url: '/alerta-expedicao' });
          setShowToast(true);
        } else if (resUunitizador.status === 'rejected') {
          let msg = montaMenssagemRetornoErroPromiseAllSettled(resUunitizador, 'Erro ao chamar /v1/expedicoes-pre-alertas-item/itens - Rejeitado.');
          setErro({ delay: 5000, tipo: 'danger', texto: msg, url: '/erro' });
          navigate('/erro')
        } else {
          setErro({ delay: 5000, tipo: 'warning', texto: `Alerta : Erro ao chamar /v1/expedicoes-pre-alertas-item/itens.`, url: '/erro' });
          navigate('/erro')
        }
        mapLinhasSelecionadas.clear();
        setSelecionarTodos(() => false);
        setShowSpinner(() => false);
      }

    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [motivoSelecionado]);

  const requestApi = (param = '') => {

    if (key === 'objetos') {
      if (param && param.length > 0) setTipoConsultaNaApi(()=>param);
      if (!dataSelecionada) setDataSelecionada(() => '1900-01-01');
      switch (param) {
        case TODOS:
          consultarUnitizadoresUnidadeDataObjetosSelecionada();
          break;
        case IDHASHUNITIZADOR:
          consultarUnitizadorPeloIdHash();
          break;
        case CODSRO_OBJETO_UNITIZADOR: case DATA_SELECIONADA:
          if (numUnitizadorConsultar) {
            numUnitizadorConsultar.length > 8 ? consultarUnitizadoresUnidadeUnitizadorOuObjeto2() : consultarUnitizadoresUnidadeDataObjetosSelecionada();
          } else {
            consultarUnitizadoresUnidadeDataObjetosSelecionada();
          }
          break;
        default:
          console.log('valor default no switch: ', param)
          break;
      }
    }

  }

  const alertasItensSituacao = (listaRecebida: IUnidadeUnitizadoresItensGeralAlerta[] = []) => {
    listaRecebida = Array.isArray(listaRecebida) && listaRecebida.length > 0 ? listaRecebida : listaUnidadeUnitizadoresItensGeralAlerta;
    ajustarTabsObjetos(listaRecebida);
  };

  const ajustarTabsObjetos = (listaRecebida: IUnidadeUnitizadoresItensGeralAlerta[] = []) => {
    let lista: IUnidadeUnitizadoresItensGeralAlerta[] = [];
    let contagem = { pendente: 0, faltante: 0, excluido: 0, local: 0, nacional: 0 };

    if (listaRecebida && listaRecebida.length > 0) {
      listaRecebida.forEach((item: IUnidadeUnitizadoresItensGeralAlerta) => {

        switch (item.codSituacao) {
          case 'F':
            contagem.faltante = contagem.faltante + 1;
            if (keyTabLocal === 'faltante') lista.push(item);
            break
          case 'E': case 'X':
            contagem.excluido = contagem.excluido + 1;
            if (keyTabLocal === 'excluido') lista.push(item);
            break
          case 'L':
            contagem.local = contagem.local + 1;
            if (keyTabLocal === 'local') lista.push(item);
            break
          case 'T':
            contagem.local = contagem.local + 1;
            if (keyTabLocal === 'local') lista.push(item);
            break
          case 'P':
            contagem.nacional = contagem.nacional + 1;
            if (keyTabLocal === 'nacional') lista.push(item);
            break
          default:
            if (keyTabLocal === 'pendente' && (!keyTabTipoCarga || !item.carga || item.carga === keyTabTipoCarga.toUpperCase() || `${item.carga}G` === keyTabTipoCarga.toUpperCase())){
              contagem.pendente = contagem.pendente + 1;
              lista.push(item);
            }

        }

      })
    }
    setListaUnidadeUnitizadoresItensGeralAlertaFiltrada(() => lista);

    setQtdItensAlertaSituacao(() => contagem);

  }

  const setFiltroInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    let valorFiltro = filtro;
    if (event) {
      event.preventDefault();
      setFiltro(() => event.target.value);
      valorFiltro = event.target.value;
    }

    aplicarFiltroInputUsuario(valorFiltro);

  }

  const aplicarFiltroInputUsuario = (valorFiltro: string) => {

    if (valorFiltro && valorFiltro !== '' && valorFiltro.length > 1) {
      let value = valorFiltro.trim().toLowerCase();
      let dataHoraAtual = dataAtualFormatada('dia', '/').concat(' 00:00:00');
      let listaFiltrada: any = [];
      //prazo máximo de entrega a vencer
      if (VERDE.includes(value) || value === VERDE || VENCER.includes(value) || value === VENCER) {
        let res = listaUnidadeUnitizadoresItensGeralAlerta.filter((linha) => {
          return linha.dataMaximaPrazo && new Date(dateTimeStringToISOFormat(linha.dataMaximaPrazo)).getTime() >= new Date(dateTimeStringToISOFormat(dataHoraAtual)).getTime();
        });
        listaFiltrada = res;
        //Prazo máximo de entrega vencido
      } else if (VERMELHO.includes(value) || value === VERMELHO || VENCIDO.includes(value) || value === VENCIDO) {
        let res = listaUnidadeUnitizadoresItensGeralAlerta.filter((linha) => {
          return linha.dataMaximaPrazo && new Date(dateTimeStringToISOFormat(linha.dataMaximaPrazo)).getTime() < new Date(dateTimeStringToISOFormat(dataHoraAtual)).getTime();
        });
        listaFiltrada = res;
        //Prazo máximo de entrega em branco, vazio, não calculado
      } else if (BRANCO.includes(value) || value === BRANCO || VAZIO.includes(value) || value === VAZIO) {
        let res = listaUnidadeUnitizadoresItensGeralAlerta.filter((linha) => {
          return !linha.dataMaximaPrazo;
        });
        listaFiltrada = res;
      } else {
        let res: any = tabLocal === SINTETICO ? aplicarFiltro(listaUnidadeUnitizadoresItensGeralAlerta, ATRIBUTOS_FILTRO_RELATORIO_ANALITICO, valorFiltro) : aplicarFiltro(listaUnidadeUnitizadoresItensGeralAlerta, montarAtributosRetorioAnalitico(keyTabLocal), valorFiltro);
        listaFiltrada = res;
      }

      ajustarTabsObjetos(listaFiltrada);

    } else {
      alertasItensSituacao(listaUnidadeUnitizadoresItensGeralAlerta);
    }

  }

  ///{idHash}/unitizador
  const consultarUnitizadorPeloIdHash = () => {

    (async function () {
      if (iPreAlertaUnitizador) {
        setShowSpinner(() => true);
        const [resLista] = await Promise.allSettled([api.get(`/v1/expedicoes-pre-alertas/${iPreAlertaUnitizador?.id}/unitizador`)]);

        if (resLista.status === 'fulfilled') {
          let res = await resLista.value.data;
          res = res.filter((item: { carga: any; }) => item?.carga === keyTabTipoCarga.toLocaleUpperCase());
          setListaUnidadeUnitizadoresItensGeralAlerta(() => res);
          setListaUnidadeUnitizadoresItensGeralAlertaFiltrada(() => res);
          alertasItensSituacao(res);
          montaRetornoUnitizadorPadraoPagination(res, setValoresPaginacao);
          setMensagem({ delay: 2000, tipo: 'info', texto: `Ok : Consulta realizada com sucesso.`, url: '/alerta-expedicao' });
          setShowToast(true);
        } else if (resLista.status === 'rejected') {
          setErro({ delay: 5000, tipo: 'danger', texto: montaMenssagemRetornoErroPromiseAllSettled(resLista, 'Erro ao chamar /v1/expedicoes-pre-alertas - Rejeitado.'), url: '/erro' });
          navigate('/erro')
        } else {
          setErro({ delay: 5000, tipo: 'warning', texto: `Alerta : Erro ao chamar /v1/expedicoes-pre-alertas - Outros.`, url: '/erro' });
          navigate('/erro')
        }
        setShowSpinner(() => false);
        setIsTabsLocalNacional(() => true);
        //Libera os demais useEffect(() para execução
        if (!didMountRef.current) didMountRef.current = true;
      }
    })();
  }

  const handleSortingChange = (accessor: string) => {
    const sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
    handleSorting(accessor, sortOrder);
  }

  const handleSorting = (sortField: string | number, sortOrder: string) => {
    const data01011900 = '01/01/1900 00:00:00';
    if (sortField) {
      const sorted = [...listaUnidadeUnitizadoresItensGeralAlertaFiltrada].sort((a, b) => {
        if ((a as Record<string, any>)[sortField] === null) return 1;
        if ((b as Record<string, any>)[sortField] === null) return -1;
        if ((a as Record<string, any>)[sortField] === null && (b as Record<string, any>)[sortField] === null) return 0;

        //Caso específico de data no formato dd/mm/aaaa faz este sort
        if (typeof sortField === 'string' && mapSortingCampoDatetime.has(sortField)) {
          let dataA = (a as Record<string, any>)[sortField];
          let dataB = (b as Record<string, any>)[sortField];
          dataA = dataA ? dataA : data01011900;
          dataB = dataB ? dataB : data01011900;
          return sortOrder === "asc" ? new Date(dateTimeStringToISOFormat(dataA.toString())).getTime() - new Date(dateTimeStringToISOFormat(dataB.toString())).getTime() : new Date(dateTimeStringToISOFormat(dataB.toString())).getTime() - new Date(dateTimeStringToISOFormat(dataA.toString())).getTime();
        } else {
          return (
            (a as Record<string, any>)[sortField].toString().localeCompare((b as Record<string, any>)[sortField].toString(), "pt-BR", {
              numeric: true,
            }) * (sortOrder === "asc" ? 1 : -1)
          );
        }
      });

      setListaUnidadeUnitizadoresItensGeralAlertaFiltrada(sorted);
    }
  };

  const consultarUnitizadoresUnidadeDataObjetosSelecionada = () => {

    if (!codSroUnidadeOrigem || codSroUnidadeOrigem.length < 8) setCodSroUnidadeOrigem(() => CEPZERO);
    let data = dataSelecionada ? dataSelecionada : '1900-01-01';
    if (data.indexOf('/') !== -1) data = data.split('/').reverse().join('-');
    setDataSelecionada(() => data);

    (async function () {
      setShowSpinner(() => true);

      const [lista] = await Promise.allSettled([api.get(`/v1/expedicoes-pre-alertas/todos-nao-conferidos/${user?.unidadeSro?.codigoSro}?codSroOrigemExpedicao=${codSroUnidadeOrigem}&dataExpedicao=${data}&tipoCarga=${keyTabTipoCarga}&situacao=${mapStatus.get(keyTabLocal.concat('s'))}&page=${currentPage < 0 ? 0 : currentPage}&size=2000`)]);

      if (lista.status === 'fulfilled') {
        const dados = await lista.value.data;

        setListaUnidadeUnitizadoresItensGeralAlerta(() => dados.content);

        alertasItensSituacao(dados.content);

        setValoresPaginacao(() => dados);

        setMensagem({ delay: 2000, tipo: 'info', texto: `Ok : Consulta realizada com sucesso.`, url: '/alerta-expedicao' });
        setShowToast(true);
      } else if (lista.status === 'rejected') {
        setMensagem({ delay: 8000, tipo: 'warning', texto: montaMenssagemRetornoErroPromiseAllSettled(lista, 'Erro ao chamar /v1/expedicoes-pre-alertas/todos-nao-conferidos - Rejeitado.'), url: '/alerta-expedicao' });
        setShowToast(true);
      } else {
        setErro({ delay: 5000, tipo: 'warning', texto: `Alerta : Erro ao chamar /v1/expedicoes-pre-alertas/todos-nao-conferidos - Outros.`, url: '/erro' });
        navigate('/erro')

      }
      setShowSpinner(() => false);
      setIsTabsLocalNacional(() => false);
      //Libera os demais useEffect(() para execução
      if (!didMountRef.current) didMountRef.current = true;
    })();
  };
  //Usados pelas acões botões faltantes e exclusão
  const selecionarTodosItens = (e: React.ChangeEvent<HTMLInputElement> | null) => {

    const status: boolean = !e ? false : e.target.checked;
    if (!e && chkCabecalho && chkCabecalho.current) chkCabecalho.current.checked = false;

    let listaUnidadeUnitizadoresItensGeralAlertaNova: IUnidadeUnitizadoresItensGeralAlerta[] = [];
    if (listaUnidadeUnitizadoresItensGeralAlerta && Array.isArray(listaUnidadeUnitizadoresItensGeralAlerta) && listaUnidadeUnitizadoresItensGeralAlerta.length > 0) {
      listaUnidadeUnitizadoresItensGeralAlerta.forEach((item) => {
        item.acao = { selecionado: false, motivo: 0 };
        listaUnidadeUnitizadoresItensGeralAlertaNova.push(item);
      });
    }

    setListaUnidadeUnitizadoresItensGeralAlerta([...listaUnidadeUnitizadoresItensGeralAlertaNova]);

    listaUnidadeUnitizadoresItensGeralAlertaNova = [];
    let mapLinhasSelecionadasNovas = new Map<String, IUnidadeUnitizadoresItensGeralAlerta>();

    listaUnidadeUnitizadoresItensGeralAlertaFiltrada.forEach((i: IUnidadeUnitizadoresItensGeralAlerta) => {
      i.acao = status ? { selecionado: true, motivo: 0 } : { selecionado: false, motivo: 0 }
      listaUnidadeUnitizadoresItensGeralAlertaNova.push(i)
      if (i.acao.selecionado && i.situacao && i.situacao.toLocaleLowerCase() === keyTabLocal) {
        mapLinhasSelecionadasNovas.set(i.idItem, i);

        let igr = listaUnidadeUnitizadoresItensGeralAlerta.filter(ig => ig.idItem === i.idItem);
        if (igr && igr.length > 0) {
          igr[0].acao = i.acao; //Seta na lista principal igual lista filtrada.
        }
      }

    })

    setListaUnidadeUnitizadoresItensGeralAlertaFiltrada([...listaUnidadeUnitizadoresItensGeralAlertaNova]);
    setMapLinhasSelecionadas(() => mapLinhasSelecionadasNovas);
    alertasItensSituacao(listaUnidadeUnitizadoresItensGeralAlertaFiltrada);
    setSelecionarTodos(status);

  }

  const selecionarItem = (e: any, item: IUnidadeUnitizadoresItensGeralAlerta) => {
    if (keyTabLocal === 'pendente' || keyTabLocal === 'faltante') {
      let qtdMap = mapLinhasSelecionadas.size;
      item.acao = { selecionado: !(item && item.acao && item.acao.selecionado), motivo: item && item.acao && item.acao.motivo ? item.acao.motivo : 0 };
      if (mapLinhasSelecionadas.has(item.idItem)) {
        let newMap = new Map(mapLinhasSelecionadas);
        newMap.delete(item.idItem);
        setMapLinhasSelecionadas(() => newMap);
        qtdMap--;
      } else {
        setMapLinhasSelecionadas(() => new Map(mapLinhasSelecionadas.set(item.idItem, item)));
        qtdMap++;
      }

      let qtd = qtdItensAlertaSituacao && new Map(Object.entries(qtdItensAlertaSituacao)).get(keyTabLocal);
      qtd = qtd ? qtd : 0;
      const isTodos = qtdMap > 0 && qtd > 0 && qtdMap === qtd;
      setSelecionarTodos(isTodos);
    }
  }


  const handleShow = (e: any, buttonClicado: string) => {

    const motivosF: IMotivoConferencia[] = motivos.filter((m: IMotivoConferencia) => {

      if (m.tipo === mapStatus.get(keyTabLocal.concat('s')) && buttonClicado === 'excluir') {

        return true;
      }
      return false;
    })
    setMotivosFiltrados([...motivosF])

    setShow(true)

  }

  const validaEtiquetaObjetoConsultar = (objeto: string, isValidaMesmoObjeto: boolean = false) => {

    if (!objeto || objeto.length !== 13) return false;

    if (isValidaMesmoObjeto) {
      //Valida se o objeto a ser consultado tem prefixo e sufixo iguais ao do objeto base
      let objetoBase = mapLinhasSelecionadas.get(Array.from(mapLinhasSelecionadas.keys())[0])?.objeto;

      if (objetoBase && (!objeto.startsWith(objetoBase.substring(0, 2)) || !objeto.endsWith(objetoBase.substring(11, 13)))) return false;
    }

    if (!objeto.match(ETIQUETA_PATTERN_NUMERO_INTERROGACAO)) return false;
    //Podem ser substituídos 3 dígitos númericos por ???. Ex: AA32???6745BR.
    if (!objeto.includes('???') || objeto.replaceAll('???', '').length !== 10) return false;
    return true;
  }

  const handleShowModalObjetoCombinacao = (e: any, objeto: string, isOrigemModal: boolean = false) => {

    if (!isOrigemModal && (!mapLinhasSelecionadas || mapLinhasSelecionadas.size !== 1)) {
      setShowModalObjetoCombinacao(false)
      let msg = !mapLinhasSelecionadas ? 'Alerta : Selecione um item para Consultar!' : 'Alerta : É permitido consultar somente um item selecionado!';
      setMensagem({ delay: 3000, tipo: 'warning', texto: msg, url: '/alerta-expedicao' });
      setShowToast(() => true);
    } else if (isOrigemModal && !validaEtiquetaObjetoConsultar(objeto, false)) {
      setMensagem({ delay: 5000, tipo: 'warning', texto: 'Obrigatório substituir três dígitos númericos, em sequência, por ???. Exemplos: XX3???24975XX, XX134???539XX, XX975324???XX, XX???324975XX', url: '/alerta-expedicao' });
      setShowToast(() => true);
    } else if (isOrigemModal && !validaEtiquetaObjetoConsultar(objeto, true)) { //Valida se o objeto a ser consultado tem prefixo e sufixo iguais ao do objeto base
      setMensagem({ delay: 5000, tipo: 'warning', texto: `Não é permitido mudar o Prefixo (Tipo Postal) ou Sufixo do objeto ${mapLinhasSelecionadas.get(Array.from(mapLinhasSelecionadas.keys())[0])?.objeto} nesta consulta.`, url: '/alerta-expedicao' });
      setShowToast(() => true);
    } else {

      (async function () {
        let objetoFonte = mapLinhasSelecionadas.get(Array.from(mapLinhasSelecionadas.keys())[0])?.objeto;
        let objetoConsultar = isOrigemModal ? objeto : objetoFonte;
        let data = mapLinhasSelecionadas.get(Array.from(mapLinhasSelecionadas.keys())[0])?.dataExpedicao;
        if (data && data.includes('/')) {
          let dt = data.split(' ')
          data = dt[0].split('/').reverse().join('-').concat('T').concat(dt[1]);
        } else {
          data = data ? data : dataHoraAtualMenosDiasFormatada('ano', '-', 90);
          data = data.replaceAll(' ', 'T');
        }

        if (!isOrigemModal && objetoConsultar) objetoConsultar = '??'.concat(objetoConsultar?.substring(2, 13));

        const [lista] = await Promise.allSettled([api.get(`/v1/expedicoes-pre-alertas-item/combinacoes?objeto=${objetoFonte}&objetoSubstituir=${objetoConsultar}&dataCriacao=${data}`)]);

        setNumObjetoConsultado(() => objetoConsultar ? isOrigemModal ? objetoConsultar : objetoConsultar.substring(0, 11).concat('??') : '');
        if (lista.status === 'fulfilled') {
          const dados = await lista.value.data;
          setListaObjetoCombinacoes(() => dados);
          setMensagem({ delay: 2000, tipo: 'info', texto: `Ok : Consulta realizada com sucesso.`, url: '/alerta-expedicao' });
          setShowToast(true);
        } else if (lista.status === 'rejected') {
          setMensagem({ delay: 5000, tipo: 'warning', texto: `Alerta : ${montaMenssagemRetornoErroPromiseAllSettled(lista, 'Erro ao chamar /v1/expedicoes-pre-alertas-item/combinacoes - Rejeitado.')}`, url: '/alerta-expedicao' });
          setShowToast(true);
        } else {
          setErro({ delay: 5000, tipo: 'warning', texto: `Alerta : Erro ao chamar /v1/expedicoes-pre-alertas-item/combinacoes - Outros.`, url: '/erro' });
          navigate('/erro')

        }

      })();

      setShowModalObjetoCombinacao(true)
    }

  }

  const montarCabecalho = () => {

    let cab = columns.map(({ label, accessor, sortable, className }) => {

      const cl = sortable ? sortField === accessor && order === "asc"
        ? <SortUp className="icon-table-sortable" />
        : sortField === accessor && order === "desc"
          ? <SortDown className="icon-table-sortable" />
          : <Justify className="icon-table-sortable" />
        : "";

      return (
        <th
          key={accessor}
          className={label === 'checkbox-cabecalho' && (keyTabLocal !== 'pendente' && keyTabLocal !== 'faltante') ? 'd-none' : `${sortable ? `${className} cursor-pointer` : `${className}`}`}
          onClick={sortable ? () => handleSortingChange(accessor) : undefined}
        >
          {cl}
          {label !== 'checkbox-cabecalho' ? label : <Form.Check ref={chkCabecalho} id='checkbox-cabecalho' type="checkbox" disabled={!listaUnidadeUnitizadoresItensGeralAlertaFiltrada || listaUnidadeUnitizadoresItensGeralAlertaFiltrada.length === 0} onChange={selecionarTodosItens} checked={selecionarTodos} />}
        </th>
      );
    });

    return cab;
  }

  const downloadAnaliticoPdf = (listaFiltrada: IUnidadeUnitizadoresItensGeralAlerta[], usuario: any, filtro: string) => {

    if (keyTabLocal === 'pendente') downloadAnaliticoPendentesPdf(listaFiltrada, usuario, filtro);
    if (keyTabLocal === 'faltante') downloadAnaliticoFaltantesPdf(listaFiltrada, usuario, filtro);

    if (keyTabLocal === 'excluido') {
      const dataHoje = dataAtualFormatada('dia', '/');
      let listaExcluidosHoje = listaFiltrada.filter(linha => linha.dataAlterado && linha.codMotivo && linha.codMotivo === 69 && (linha.dataAlterado.split(' ')[0] === dataHoje || (linha.dataAlterado.split('T')[0] && linha.dataAlterado === dataHoje)));
      if (listaExcluidosHoje && Array.isArray(listaExcluidosHoje) && listaExcluidosHoje.length > 0) {
        let listaExcluidosHojeValidar = listaExcluidosHoje.filter(linha => linha.codSroOrigem !== listaExcluidosHoje[0].codSroOrigem);
        if (listaExcluidosHojeValidar && Array.isArray(listaExcluidosHojeValidar) && listaExcluidosHojeValidar.length > 0) {
          setMensagem({ delay: 10000, tipo: 'warning', texto: `Alerta : sroconferencia - Faça o filtro de uma única Unidade de origem para geração do ROE.`, url: '/alerta-expedicao' });
          setShowToast(true);
          return;
        }

        const idHashPDF = gerarHashMd5ParaPDF(usuario.unidadeSro.codigoSro, listaExcluidosHoje);

        (async function () {
          const [resPdf] = await Promise.allSettled([api.get(`/v1/relatorio-alerta-excluido/id/${idHashPDF}`)]);

          if (resPdf.status === 'fulfilled') {
            let res = await resPdf.value.data;
            downloadBase64PDF(res.nomeDocumento, res.pdfDocumento);
            setMensagem({ delay: 5000, tipo: 'info', texto: `Ok : ${res.nomeDocumento} emitido anteriormente.`, url: '/alerta-expedicao' });
            setShowToast(true);
          } else {
            let pdf = await downloadAnaliticoExcluidosPdf(listaExcluidosHoje, usuario, filtro, idHashPDF);

            const [resUunitizador] = await Promise.allSettled([api.post(`/v1/relatorio-alerta-excluido`, pdf)]);

            if (resUunitizador.status === 'fulfilled') {
              setMensagem({ delay: 2000, tipo: 'info', texto: `Ok : Relatório excluído gerado e gravado com sucesso.`, url: '/alerta-expedicao' });
              setShowToast(true);
            } else if (resUunitizador.status === 'rejected') {
              let msg = montaMenssagemRetornoErroPromiseAllSettled(resUunitizador, 'Erro ao chamar /v1/relatorio-alerta-excluido - Rejeitado.');

              setErro({ delay: 5000, tipo: 'danger', texto: msg, url: '/erro' });
              navigate('/erro')
            } else {
              setErro({ delay: 5000, tipo: 'warning', texto: `Alerta : Erro ao chamar /v1/relatorio-alerta-excluido.`, url: '/erro' });
              navigate('/erro')
            }

          }
        })();

      } else {
        setMensagem({ delay: 10000, tipo: 'warning', texto: `Alerta : sroconferencia - Não tem objeto excluído hoje para gerar o relatório.`, url: '/alerta-expedicao' });
        setShowToast(true);
      }

    };
  }

  const returnCustomizadaTd = (accessor: string, data: any) => {
    let dataHoraAtual = dataAtualFormatada('dia', '/').concat(' 00:00:00');
    let dataMaxima = data.dataMaximaPrazo ? data.dataMaximaPrazo.split(' ')[0] : data.dataMaximaPrazo;
    if (accessor === 'objeto') return <td key={accessor} id={accessor} className='text-center'><a className={isLinkClicado(data.objeto) ? 'visited' : ''} onClick={(e) => linkClicado(data.objeto)} title={`Clique para rastrear o objeto ${data.objeto}`} href={`${process.env.REACT_APP_URL_PAGE_RASTREAMENTO}?objetos=${data.objeto}`} target="_blank" rel="noopener noreferrer"><strong>{data.objeto}</strong></a></td>
    if (accessor === 'numUnitizador') return <td key={accessor} id={accessor} className='text-center'><a className={isLinkClicado(data.numUnitizador) ? 'visited' : ''} onClick={(e) => linkClicado(data.numUnitizador)} title={`Clique para rastrear o unitizador ${data.numUnitizador}`} href={`${process.env.REACT_APP_URL_PAGE_RASTREAMENTO}?objetos=${data.numUnitizador}`} target="_blank" rel="noopener noreferrer"><strong>{data.numUnitizador}</strong></a></td>
    if (accessor === 'dataMaximaPrazo') return <td key={accessor} id={accessor} className={data.dataMaximaPrazo && new Date(dateTimeStringToISOFormat(data.dataMaximaPrazo)).getTime() >= new Date(dateTimeStringToISOFormat(dataHoraAtual)).getTime() ? 'text-center text-success' : 'text-center text-danger'}>{dataMaxima}</td>

    return <td key={accessor} id={accessor} className={(keyTabLocal === 'pendente' || keyTabLocal === 'faltante') ? 'text-center' : 'd-none'}>
      <Form.Check id={data.idItem} type="checkbox" className="ckeckbox-item" disabled={(keyTabLocal === 'local' || keyTabLocal === 'nacional')} onChange={() => { return false }} checked={data && data.acao && data.acao.selecionado ? true : false} />
    </td>

  }

  const consultarUnitizadoresUnidadeUnitizadorOuObjeto = () => {
    if (numUnitizadorConsultar && numUnitizadorConsultar.length === 8) setCodSroUnidadeOrigem(() => numUnitizadorConsultar);
    setKeyTabBtnConsultarCodSroOUUniOuObj(keyTabBtnConsultarCodSroOUUniOuObj === A ? B : A);
  };
  const consultarUnitizadoresUnidadeUnitizadorOuObjeto2 = () => {

    (async function () {

      const [resUunitizador] = await Promise.allSettled([api.get(`/v1/expedicoes-pre-alertas/${user?.unidadeSro?.codigoSro}?unitizador=${numUnitizadorConsultar}`)]);

      if (resUunitizador.status === 'fulfilled') {
        const u = await resUunitizador.value.data;

        setListaUnidadeUnitizadoresItensGeralAlerta(() => u)
        setListaUnidadeUnitizadoresItensGeralAlertaFiltrada(() => u);
        montaRetornoUnitizadorPadraoPagination(u, setValoresPaginacao);

      } else if (resUunitizador.status === 'rejected') {
        setUnitizador(undefined);
        setMensagem({ delay: 5000, tipo: 'danger', texto: montaMenssagemRetornoErroPromiseAllSettled(resUunitizador, 'Erro ao chamar /v1/expedicoes-pre-alertas - Rejeitado.'), url: '/alerta-expedicao' });
        setShowToast(true);
      } else {
        setUnitizador(undefined);
        setMensagem({ delay: 5000, tipo: 'warning', texto: `Alerta : Erro ao chamar /v1/expedicoes-pre-alertas - Outros.`, url: '/alerta-expedicao' });
        setShowToast(true);
      }

      //setNumUnitizadorConsultar('')
      setIsTabsLocalNacional(() => true)
    })();

  }

  const setTabConsultar = (tabSelecionada: string = 'pendente') => {
    setDataSelecionada(() => '');
    setNumUnitizadorConsultar(() => '');
    setCodSroUnidadeOrigem(() => CEPZERO);
    if(tabSelecionada === 'urg' || tabSelecionada === 'nurg'){
      setKeyTabTipoCarga(() => tabSelecionada);
    }else{
      setKeyTabLocal(() => tabSelecionada);
    }
  }

  return (

    <>
      <FiltrarExportar
      filtro={filtro}
      lista={listaUnidadeUnitizadoresItensGeralAlertaFiltrada}
      keyTabLocal={keyTabLocal}
      numUnitizadorOuObjetoConsultar={numUnitizadorConsultar}
      setNumUnitizadorOuObjetoConsultar={setNumUnitizadorConsultar}
      setFiltroInput={setFiltroInput}
      consultarCodSroOrigemOuUnitizadorOuObjeto={consultarUnitizadoresUnidadeUnitizadorOuObjeto}
      downloadAnaliticoPdf={downloadAnaliticoPdf}
      header_csv={ATRIBUTOS_HEADER_RELATORIO_ANALITICO_CSV}
      placeholderCodSroUnitizadorObjeto={"Untizador/Objeto/Código SRO"}
      setCurrentPage={setCurrentPage}
      />

      <Row className="mx-0">
        <Col sm={12} lg={6}>
          <Tabs id="tabsTipoCarga" defaultActiveKey="urg"
            activeKey={keyTabTipoCarga}
            onSelect={(k) => setTabConsultar(k ? k : 'urg')}
            className={`mb-2 image-tab-tipo-carga-objetos ${keyTabLocal !== Constants.PENDENTE.toLocaleLowerCase() ? 'd-none' : ''}`}>
            <Tab tabClassName="py-1" eventKey="urg"
              title={<span>Urgente{<img src={EctAlertaUrgente}
                alt="Logo ECT"
              />}</span>}
            />
            <Tab tabClassName="py-1" eventKey="nurg" title={<span>Não Urgente{<img src={EctAlertaNaoUrgente}
              alt="Logo ECT"
            />}</span>}
            />
          </Tabs>
        </Col>
        <Col sm={12} lg={6} className="align-middle pt-1">
          {valoresPaginacao && valoresPaginacao.dataInicioPeriodo && valoresPaginacao.dataFinalPeriodo ?
            <React.Fragment>
              <h5 className="ps-2 border rounded">{`Período: ${valoresPaginacao?.dataInicioPeriodo} a ${valoresPaginacao?.dataFinalPeriodo}`}</h5>
            </React.Fragment>

            :

            <React.Fragment />

          }
        </Col>
        <Col sm={12} lg={6}>
          <Tabs defaultActiveKey="pendente"
            activeKey={keyTabLocal}
            onSelect={(k) => setTabConsultar(k ? k : 'pendente')}
            className="mb-2"
          >
            <Tab eventKey={"pendente"} title={
              <React.Fragment>
                Pendente(s)
                <Badge bg="primary" className="ms-1">{qtdItensAlertaSituacao.pendente}</Badge>
              </React.Fragment>
            } />
            <Tab eventKey="faltante" disabled={false} title={
              <React.Fragment>
                Faltante(s)
                <Badge bg="primary" className="ms-1">{qtdItensAlertaSituacao.faltante}</Badge>
              </React.Fragment>
            } />
            <Tab eventKey="excluido" title={
              <React.Fragment>
                Excluído(s)
                <Badge bg="primary" className="ms-1">{qtdItensAlertaSituacao.excluido}</Badge>
              </React.Fragment>
            } />

            {(isTabsLocalNacional) &&

              <Tab eventKey="local" title={
                <React.Fragment>
                  Local
                  <Badge bg="primary" className="ms-1">{qtdItensAlertaSituacao.local}</Badge>
                </React.Fragment>
              } />

            }

            {(isTabsLocalNacional) &&
              <Tab eventKey="nacional" title={
                <React.Fragment>
                  Nacional
                  <Badge bg="primary" className="ms-1">{qtdItensAlertaSituacao.nacional}</Badge>
                </React.Fragment>
              } />
            }

          </Tabs>
        </Col>
        <Col sm={12} lg={6} className="mt-0 pb-2 gap-5">

          <ButtonGroup className={tabLocal === ANALITICO ? 'mb-2 w-100 h-100' : 'd-none'}>

            <Button variant="primary" className=" ps-0 py-0" disabled={!mapLinhasSelecionadas || mapLinhasSelecionadas.size === 0} onClick={(e) => { handleShowModalObjetoCombinacao(e, N) }}><Search className="icon-search" size={24} />Trocar Letras</Button>
            <Button variant="primary" className=" ps-0 py-0" disabled={mapLinhasSelecionadas.size === 0 || (mapLinhasSelecionadas.size >= 0 && (keyTabLocal === 'local' || keyTabLocal === 'nacional'))} onClick={(e) => { handleShow(e, N) }}><FolderMinus color='yellow' size={24} /> Faltantes</Button>
            <Button variant="primary" className=" ps-0 py-0" disabled={mapLinhasSelecionadas.size === 0 || (mapLinhasSelecionadas.size >= 0 && (keyTabLocal === 'excluido' || keyTabLocal === 'local' || keyTabLocal === 'nacional'))} onClick={(e) => { handleShow(e, 'excluir') }}><FolderX color='red' size={24} /> Excluir</Button>

          </ButtonGroup>

        </Col>

        <Col sm={10} className="mt-0 pb-0 gap-5">

          <PaginationComponent
            itemsCount={valoresPaginacao && valoresPaginacao.totalElements ? valoresPaginacao.totalElements : 0}
            itemsPerPage={2000}
            totalPages={valoresPaginacao && valoresPaginacao.totalPages ? valoresPaginacao.totalPages : 0}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            alwaysShown={false}
          />

        </Col>
        <Col sm={2} className="mt-0 pt-0 pb-0 gap-5 text-center align-middle fs-5 border rounded">
          {valoresPaginacao && valoresPaginacao.totalElements && valoresPaginacao.totalElements > 0 && listaUnidadeUnitizadoresItensGeralAlertaFiltrada ?
            <React.Fragment>
              <h5 className="pt-1">{`Mostrando ${listaUnidadeUnitizadoresItensGeralAlertaFiltrada.length} ite${listaUnidadeUnitizadoresItensGeralAlertaFiltrada.length > 1 ? 'ns' : 'm'} de ${valoresPaginacao.totalElements}.`}</h5>

            </React.Fragment>
            :

            <React.Fragment />

          }
        </Col>

      </Row>
      <div ref={divTable} className="mb-2 mt-1">
        <Table id="tabela-lista-expedicao-pendente" responsive striped className="scroll mb-0">
          <thead>
            <tr>
              {montarCabecalho()}
            </tr>
          </thead>
          {listaUnidadeUnitizadoresItensGeralAlertaFiltrada && listaUnidadeUnitizadoresItensGeralAlertaFiltrada.length > 0 ?

            (<tbody>
              {listaUnidadeUnitizadoresItensGeralAlertaFiltrada.map((data: any, index: number) => {

                if ('objeto' in data && !data?.acao) data.acao = { selecionado: false, motivo: 0 }

                return (

                  <tr id={String(index)} key={index} onClick={(e) => selecionarItem(e, data)} className={data && data.acao && data.acao.selecionado ? 'cursor-pointer row-selecionada' : 'cursor-pointer'}>
                    {columns.map(({ accessor, classNameData }) => {

                      const tData = accessor !== 'numUnitizador' && accessor !== 'objeto' && accessor !== 'dataMaximaPrazo' && ((data as Record<string, any>)[accessor] || (data as Record<string, any>)[accessor] >= 0) ? (data as Record<string, any>)[accessor] : "checkbox";

                      return tData !== "checkbox" ? <td key={accessor} id={accessor} className={!classNameData || classNameData === "" ? "" : classNameData}>{tData}</td>
                        :

                        returnCustomizadaTd(accessor, data);

                    })}
                  </tr>
                );
              })}
            </tbody>)

            :

            (<tbody><tr><td key={new Date().toLocaleDateString()} colSpan={columns.length} className="text-center"><strong className="text-center">Não encontrou dados.</strong></td></tr></tbody>)
          }

        </Table>
      </div>

      <ModalSituacao
        motivosFiltrados={motivosFiltrados}
        motivoSelecionado={motivoSelecionado}
        setMotivoSelecionado={setMotivoSelecionado}
        show={show}
        setShow={setShow}
      />

      <ConsultaObjetoPorCombinacao
        numObjetoConsultado={numObjetoConsultado}
        linhaSelecionada={mapLinhasSelecionadas.get(Array.from(mapLinhasSelecionadas.keys())[0])}
        listaObjetoCombinacoes={listaObjetoCombinacoes}
        show={showModalObjetoCombinacao}
        setShow={setShowModalObjetoCombinacao}
        handleShowModalObjetoCombinacao={handleShowModalObjetoCombinacao}
      />

      {showToast ?
        <ToastCustomizado
          show={showToast}
          setShow={setShowToast}
          mensagem={mensagem && mensagem.texto ? mensagem.texto : undefined}
          tipo={mensagem && mensagem.tipo ? mensagem.tipo : ''}
          delay={mensagem?.delay}
        />
        : null}
      <Row className="mb-2 ms-0 me-0 ps-1">
        <Col sm={10} className="mb-3 mt-0 pb-2 gap-5">

          <PaginationComponent
            itemsCount={valoresPaginacao && valoresPaginacao.totalElements ? valoresPaginacao.totalElements : 0}
            itemsPerPage={2000}
            totalPages={valoresPaginacao && valoresPaginacao.totalPages ? valoresPaginacao.totalPages : 0}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            alwaysShown={false}
          />



        </Col>
        <Col sm={2} className="mt-0 pb-0 h-50 text-center align-middle fs-5 border rounded ps-0">
          {valoresPaginacao && valoresPaginacao.totalElements && valoresPaginacao.totalElements > 0 && listaUnidadeUnitizadoresItensGeralAlertaFiltrada ?
            <React.Fragment>
              <h5 className="pt-1">{`Mostrando ${listaUnidadeUnitizadoresItensGeralAlertaFiltrada.length} ite${listaUnidadeUnitizadoresItensGeralAlertaFiltrada.length > 1 ? 'ns' : 'm'} de ${valoresPaginacao.totalElements}.`}</h5>

            </React.Fragment>
            :

            <React.Fragment />

          }
        </Col>
      </Row>

    </>
  )
}

export default ListaUnitizadorUnidadeDataObjetos